import React, {useContext} from 'react'
import {ArrowRightOnRectangleIcon, UserCircleIcon} from "@heroicons/react/24/solid";
import {appConfig, logout} from "../firebase/client-app";
import AppContext from "../common/context/app-context";

const menus = [
    {name: 'Designs', href: '/designs'},
    {name: 'Quotes', href: '/quotes'},
    {name: 'POD', href: '/pods'},
    {name: 'Tags', href: '/tags'},
    {name: 'Themes', href: '/themes'},
    {name: 'Images', href: '/images'},
    {name: 'Shopify', href: '/shopify'},
    {name: 'Printful', href: '/printful'},
    {name: 'Facebook', href: '/facebook'},
    {name: 'Pinterest', href: '/pinterest'},
    {name: 'Marketing', href: '/marketing', showCount: true},
    {name: 'Content', href: '/content'},
    {name: 'Utilities', href: '/utilities'},
    {name: 'Master Data', href: '/master-data'},
    /*{name: 'Konva', href: '/konva'},
    {name: 'Designer', href: '/designer'},*/
]

const Header = () => {
    const appContext = useContext(AppContext);
    let {profile, isAuthenticated, initiateLogout} = appContext;

    return (
        <>
            <div className="sticky top-0 left-0 w-full mx-auto">
                <div className="max-w-full mx-auto">
                    <div className="relative z-10 bg-slate-500">

                        <div className="relative">
                            <div className="relative flex items-center justify-between h-fit py-4 text-white"
                                 aria-label="Global">
                                <div className="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
                                    <a href={'/'} className="flex items-center justify-between w-full ml-4">
                                        {appConfig?.appName}
                                    </a>
                                </div>

                                {isAuthenticated &&
                                    <div className="flex flex-wrap mx-4 items-end">
                                        {menus.map((item, index) => (
                                            <div key={index}>
                                                <a href={item.href}
                                                   className="font-medium text-white hover:text-gray-300 pr-2">
                                                    {item.name}
                                                    {/*{item.showCount &&
                                                        <span className="ml-1">({shopifyDetail?.total})</span>
                                                    }*/}
                                                </a>
                                                {index < menus.length - 1 &&
                                                    <span className="mr-2">|</span>
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }

                                {isAuthenticated &&
                                    <div className="flex mr-4 items-center">
                                        <span className="ml-2 mr-2 text-white">
                                            <UserCircleIcon className="h-6 w-6"/>
                                        </span>
                                        <span className="font-light pr-4">
                                        {profile?.profile?.displayName}
                                            {profile?.displayName}
                                            </span>
                                        <button onClick={initiateLogout}
                                                className="font-light hover:text-gray-200 pr-2 cursor-pointer">
                                            <ArrowRightOnRectangleIcon className="h-6 w-6"/>
                                        </button>
                                    </div>
                                }

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Header
